import { DepartmentModel } from '@/models/department.model'
import { api } from '@/services/api'

type FetchActiveDepartmentsParams = {
  companyId: string
}

export type FetchActiveDepartmentsResponse = {
  departments: DepartmentModel[]
}

export async function fetchActiveDepartments(params: FetchActiveDepartmentsParams) {
  const response = await api.get<FetchActiveDepartmentsResponse>(`/departments/find-actives/${params.companyId}`)
  return response.data
}
